import { MultiToggle, Option } from "PFComponents/multi_toggle";
import { useTranslation } from "react-i18next";

import { ProfileSource } from "./profile_source";

type DisabledSpec = { disabled: boolean; tooltip?: string };

type ProfileSourceToggleProps = {
  value: ProfileSource | null;
  onChange: (value: ProfileSource) => void;
  allowedSources?: ProfileSource[];
  disabledSources?: Partial<Record<ProfileSource, DisabledSpec>>;
  fluid?: boolean;
  className?: string;
};

const ALL_SOURCES: ProfileSource[] = [
  ProfileSource.Shortlist,
  ProfileSource.Matches,
  ProfileSource.NamedResource
];

const I18N_KEY = {
  [ProfileSource.Matches]: "profilesSelector.matches",
  [ProfileSource.Shortlist]: "profilesSelector.shortlist",
  [ProfileSource.NamedResource]: "profilesSelector.namedResource"
} as const;

export const ProfileSourceToggle = ({
  value,
  onChange,
  allowedSources = ALL_SOURCES,
  disabledSources,
  fluid = true,
  className
}: ProfileSourceToggleProps) => {
  const { t } = useTranslation();

  const visibleSources = ALL_SOURCES.filter((source) => allowedSources.includes(source));

  if (visibleSources.length <= 1) {
    return null;
  }

  const options: Option<ProfileSource>[] = visibleSources.map((source) => {
    const spec = disabledSources?.[source];
    return {
      id: source,
      value: t(I18N_KEY[source]),
      disabled: spec?.disabled,
      tooltipContent: spec?.tooltip || false
    };
  });

  return (
    <MultiToggle<ProfileSource>
      classes={{ root: className }}
      options={options}
      controlledValue={value}
      onChange={onChange}
      fluid={fluid}
    />
  );
};
